import request from "@/api/request";

export function noticeTimeline() {
    return request({
        url: '/api/notice/noticeTimeline',
        method: 'get'
    })
}




